
const STATES = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'];
const POSTCODE_KEY = 'divano:freight-postcode';
const REGION_KEY = 'divano:region-tag';
const REGION_PARAM = 'divano_region';
const REGION_TTL_MS = 30 * 24 * 60 * 60 * 1000;

function stateOf(postcode) {
  const n = Number(postcode);
  if (n >= 800 && n <= 999) return 'NT';
  if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
  if (n >= 1000 && n <= 2999) return 'NSW';
  if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
  if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
  if (n >= 5000 && n <= 5999) return 'SA';
  if (n >= 6000 && n <= 6999) return 'WA';
  if (n >= 7000 && n <= 7999) return 'TAS';
  return '';
}

function postcodeState() {
  try {
    const postcode = sessionStorage.getItem(POSTCODE_KEY) || '';
    return /^\d{4}$/.test(postcode) ? stateOf(postcode) : '';
  } catch {
    return '';
  }
}

function regionTag() {
  let fromUrl = '';
  try {
    fromUrl = (new URLSearchParams(window.location.search).get(REGION_PARAM) || '').trim().toUpperCase();
  } catch {
    fromUrl = '';
  }
  if (STATES.includes(fromUrl)) {
    try {
      localStorage.setItem(REGION_KEY, JSON.stringify({ region: fromUrl, expires: Date.now() + REGION_TTL_MS }));
    } catch {
    }
    return fromUrl;
  }

  try {
    const raw = localStorage.getItem(REGION_KEY);
    if (!raw) return '';
    const stored = JSON.parse(raw);
    if (stored && STATES.includes(stored.region) && Number(stored.expires) > Date.now()) return stored.region;
    localStorage.removeItem(REGION_KEY);
  } catch {
    try {
      localStorage.removeItem(REGION_KEY);
    } catch {
    }
  }
  return '';
}

const signalled = new Set([postcodeState(), regionTag()].filter(Boolean));

if (!customElements.get('divano-price-beat')) {
  class DivanoPriceBeat extends HTMLElement {
    connectedCallback() {
      const ticked = (this.dataset.states || '').split(' ');
      if (ticked.some((code) => signalled.has(code))) this.hidden = false;
    }
  }

  customElements.define('divano-price-beat', DivanoPriceBeat);
}
